"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function EditTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'edit',
    theme: 'twotone',
    nameWithTheme: 'edit-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        d: 'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9c3.9-3.9 3.9-10.2 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2c-1.9 11.1 1.5 21.9 9.4 29.8 6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z',
        fill: primaryColor
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'edit-twotone';
var EditTwoTone = temp;
exports.default = EditTwoTone;